<template>
  <v-card>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card-title>
        <span class="text-h5">{{ titleCard }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field label="Nombre*" v-model="dataForm.nombre" required :rules="[campoRequerido]"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field label="Dni *" v-model="dataForm.dni" required :rules="[campoRequerido]"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field label="Correo*" v-model="dataForm.correo" required :rules="[campoRequerido]"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field label="Teléfono*" v-model="dataForm.telefono" required
                :rules="[campoRequerido]"></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeEdit">
          Cancelar
        </v-btn>
        <v-btn color="blue darken-1" text @click="editItem" v-if="statusEdit">
          Guardar
        </v-btn>
        <v-btn color="blue darken-1" text @click="createItem" v-if="!statusEdit">
          Crear
        </v-btn>
      </v-card-actions>
    </v-form>
    <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
      <v-card color="#1973a5" dark>
        <v-card-text>
          Cargando Datos
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<style>
.bg-primary-table {
  font-weight: 400;
}

.text-start {
  font-size: 0.8rem !important;
}

.container {
  max-width: 3000px !important;
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
export default {
  props: {
    sendData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      titleCard: "Nuevo médico",
      dataForm: {
        idMedico: "",
        nombre: "",
        dni: "",
        correo: "",
        telefono: ""
      },
      statusEdit: false,
      menu: false,
      date: null,
      valid: true,
      dialogLoader: false,
      campoRequerido: (v) => !!v || "Campo Obligatorio.",
    };
  },
  methods: {
    closeEdit() {
      this.statusEdit = false;
      this.$emit("closeEdit");
    },
    editItem() {
      if (!this.$refs.form.validate()) {
        Swal.fire({
          title: "¡Error!",
          text: "¡Debe completar los campos obligatorios!",
          icon: "error",
        });
        return;
      }
      this.dialogLoader = true;
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .patch(RUTA_API + "/medico/" + this.dataForm.idMedico + "/", this.dataForm, {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              this.dialogLoader = false;
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Se editó correctamente!",
                icon: "success",
              });
              this.closeEdit();
            })
            .catch((res) => {
              this.dialogLoader = false;
              Swal.fire({
                title: "¡Error!",
                text: "¡No se pudo editar el formulario!",
                icon: "error",
                confirmButtonText: "Aceptar",
              });
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    loadData() {
      this.dataForm = this.sendData;
      console.log("datos del formulario", this.dataForm);
    },
    createItem() {
      if (!this.$refs.form.validate()) {
        Swal.fire({
          title: "¡Error!",
          text: "¡Debe completar los campos obligatorios!",
          icon: "error",
        });
        return;
      }
      this.dialogLoader = true;
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(RUTA_API + "/medico/", this.dataForm, {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              this.dialogLoader = true;
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Se registró correctamente!",
                icon: "success",
              });
              this.closeEdit();
            })
            .catch((res) => {
              this.dialogLoader = true;
              Swal.fire({
                title: "¡Error!",
                text: "¡No se pudo registrar el formulario!",
                icon: "error",
                confirmButtonText: "Aceptar",
              });
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
  },
  mounted() { },
  computed: {
  },
  created() {
    if (this.sendData.idMedico) {
      console.log("data enviadad", this.sendData);
      this.titleCard = "Editar Médico";
      this.statusEdit = true;
      this.loadData();
    }
  },
  components: {
  },
};
</script>